import React from 'react'
import '../componentStyles/Loader.css'
function Loader() {
  return (
    <div className='routerContainer loaderContainer'>
        <div className='outerLoader'>
        </div>
    </div>
  )
}


export default Loader